import { render, staticRenderFns } from "./parking_spaces_assignment.vue?vue&type=template&id=1304b91f&scoped=true"
import script from "./parking_spaces_assignment.vue?vue&type=script&lang=js"
export * from "./parking_spaces_assignment.vue?vue&type=script&lang=js"
import style0 from "./parking_spaces_assignment.vue?vue&type=style&index=0&id=1304b91f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304b91f",
  null
  
)

export default component.exports